// client/src/store/products_config/components/categories.taxonomy.js

// ID scheme: top-level 1000s, children 1100s, leaves 1110 etc.
// This is a broad, Amazon/Alibaba-style coverage across retail.

export const CATEGORIES = [
  /* 1000 — Electronics -------------------------------------------------- */
  {
    id: 1000, name: "Electronics", children: [
      { id: 1100, name: "Phones & Accessories", children: [
        { id: 1110, name: "Smartphones" },
        { id: 1120, name: "Feature Phones" },
        { id: 1130, name: "Phone Cases" },
        { id: 1140, name: "Chargers & Cables", children: [
          { id: 1141, name: "Wall Chargers" },
          { id: 1142, name: "Wireless Chargers" },
          { id: 1143, name: "Car Chargers" },
          { id: 1144, name: "USB Cables" },
          { id: 1145, name: "Power Banks" },
        ]},
        { id: 1150, name: "Screen Protectors" },
        { id: 1160, name: "Phone Accessories (Other)" },
      ]},
      { id: 1200, name: "Computers & Tablets", children: [
        { id: 1210, name: "Laptops", children: [
          { id: 1211, name: "Ultrabooks" },
          { id: 1212, name: "Gaming Laptops" },
          { id: 1213, name: "2-in-1 Laptops" },
        ]},
        { id: 1220, name: "Desktops", children: [
          { id: 1221, name: "Towers" },
          { id: 1222, name: "All-in-One" },
          { id: 1223, name: "Mini PCs" },
        ]},
        { id: 1230, name: "Tablets", children: [
          { id: 1231, name: "Android Tablets" },
          { id: 1232, name: "iPad" },
          { id: 1233, name: "Windows Tablets" },
        ]},
        { id: 1240, name: "Monitors" },
        { id: 1250, name: "PC Components", children: [
          { id: 1251, name: "CPUs" },
          { id: 1252, name: "GPUs" },
          { id: 1253, name: "Motherboards" },
          { id: 1254, name: "RAM" },
          { id: 1255, name: "SSDs" },
          { id: 1256, name: "HDDs" },
          { id: 1257, name: "Power Supplies" },
          { id: 1258, name: "PC Cases" },
          { id: 1259, name: "Cooling" },
        ]},
        { id: 1260, name: "Networking", children: [
          { id: 1261, name: "Wi-Fi Routers" },
          { id: 1262, name: "Mesh Systems" },
          { id: 1263, name: "Modems" },
          { id: 1264, name: "Switches" },
        ]},
        { id: 1270, name: "Keyboards & Mice" },
        { id: 1280, name: "External Storage", children: [
          { id: 1281, name: "External SSD" },
          { id: 1282, name: "External HDD" },
          { id: 1283, name: "NAS" },
        ]},
      ]},
      { id: 1300, name: "TV & Home Theater", children: [
        { id: 1310, name: "Televisions", children: [
          { id: 1311, name: "LED / LCD" },
          { id: 1312, name: "OLED" },
          { id: 1313, name: "QLED / Mini-LED" },
        ]},
        { id: 1320, name: "Projectors & Screens" },
        { id: 1330, name: "Streaming Media Players" },
        { id: 1340, name: "Soundbars" },
        { id: 1350, name: "AV Receivers" },
        { id: 1360, name: "Home Speakers" },
      ]},
      { id: 1400, name: "Audio", children: [
        { id: 1410, name: "Headphones", children: [
          { id: 1411, name: "Over-Ear" },
          { id: 1412, name: "In-Ear" },
          { id: 1413, name: "True Wireless" },
        ]},
        { id: 1420, name: "Portable Speakers" },
        { id: 1430, name: "Smart Speakers" },
        { id: 1440, name: "Microphones" },
        { id: 1450, name: "DACs & Amps" },
      ]},
      { id: 1500, name: "Cameras & Photo", children: [
        { id: 1510, name: "Digital Cameras", children: [
          { id: 1511, name: "DSLR" },
          { id: 1512, name: "Mirrorless" },
          { id: 1513, name: "Point-and-Shoot" },
        ]},
        { id: 1520, name: "Lenses" },
        { id: 1530, name: "Action Cameras" },
        { id: 1540, name: "Camera Drones" },
        { id: 1550, name: "Tripods & Supports" },
        { id: 1560, name: "Flashes & Lighting" },
        { id: 1570, name: "Memory Cards" },
      ]},
      { id: 1600, name: "Wearables & VR", children: [
        { id: 1610, name: "Smartwatches" },
        { id: 1620, name: "Fitness Trackers" },
        { id: 1630, name: "VR/AR Headsets" },
      ]},
      { id: 1700, name: "Smart Home", children: [
        { id: 1710, name: "Smart Lighting" },
        { id: 1720, name: "Smart Plugs & Switches" },
        { id: 1730, name: "Thermostats" },
        { id: 1740, name: "Security Cameras" },
        { id: 1750, name: "Video Doorbells" },
        { id: 1760, name: "Hubs & Sensors" },
        { id: 1770, name: "Robot Vacuums" },
      ]},
      { id: 1800, name: "Automotive Electronics", children: [
        { id: 1810, name: "Car Audio" },
        { id: 1820, name: "Dash Cams" },
        { id: 1830, name: "GPS & Navigation" },
        { id: 1840, name: "OBD Scanners" },
        { id: 1850, name: "Jump Starters" },
      ]},
    ],
  },

  /* 2000 — Home & Kitchen --------------------------------------------- */
  {
    id: 2000, name: "Home & Kitchen", children: [
      { id: 2100, name: "Furniture", children: [
        { id: 2110, name: "Living Room", children: [
          { id: 2111, name: "Sofas & Sectionals" },
          { id: 2112, name: "Coffee Tables" },
          { id: 2113, name: "TV Stands" },
        ]},
        { id: 2120, name: "Bedroom", children: [
          { id: 2121, name: "Beds & Frames" },
          { id: 2122, name: "Mattresses" },
          { id: 2123, name: "Wardrobes" },
          { id: 2124, name: "Dressers" },
        ]},
        { id: 2130, name: "Dining Room", children: [
          { id: 2131, name: "Dining Sets" },
          { id: 2132, name: "Dining Chairs" },
          { id: 2133, name: "Dining Tables" },
        ]},
        { id: 2140, name: "Office Furniture", children: [
          { id: 2141, name: "Office Chairs" },
          { id: 2142, name: "Desks" },
          { id: 2143, name: "Storage" },
        ]},
      ]},
      { id: 2200, name: "Kitchen & Dining", children: [
        { id: 2210, name: "Cookware & Bakeware" },
        { id: 2220, name: "Cutlery & Utensils" },
        { id: 2230, name: "Dinnerware & Drinkware" },
        { id: 2240, name: "Small Appliances", children: [
          { id: 2241, name: "Air Fryers" },
          { id: 2242, name: "Blenders" },
          { id: 2243, name: "Coffee Makers" },
          { id: 2244, name: "Kettles" },
          { id: 2245, name: "Toasters" },
          { id: 2246, name: "Microwaves (Countertop)" },
        ]},
        { id: 2250, name: "Food Storage & Organization" },
        { id: 2260, name: "Water Filters" },
      ]},
      { id: 2300, name: "Home Décor", children: [
        { id: 2310, name: "Rugs" },
        { id: 2320, name: "Curtains & Blinds" },
        { id: 2330, name: "Wall Art & Frames" },
        { id: 2340, name: "Mirrors" },
        { id: 2350, name: "Lighting", children: [
          { id: 2351, name: "Ceiling Lights" },
          { id: 2352, name: "Table & Floor Lamps" },
          { id: 2353, name: "Outdoor Lighting" },
        ]},
      ]},
      { id: 2400, name: "Bedding & Bath", children: [
        { id: 2410, name: "Sheets & Pillowcases" },
        { id: 2420, name: "Duvet Covers & Comforters" },
        { id: 2430, name: "Pillows" },
        { id: 2440, name: "Towels" },
        { id: 2450, name: "Shower Curtains" },
      ]},
      { id: 2500, name: "Cleaning & Organization", children: [
        { id: 2510, name: "Laundry Detergent" },
        { id: 2520, name: "Surface Cleaners" },
        { id: 2530, name: "Mops & Brooms" },
        { id: 2540, name: "Vacuum Cleaners" },
        { id: 2550, name: "Steam Cleaners" },
      ]},
      { id: 2600, name: "Heating, Cooling & Air", children: [
        { id: 2610, name: "Heaters" },
        { id: 2620, name: "Fans" },
        { id: 2630, name: "Air Conditioners" },
        { id: 2640, name: "Air Purifiers" },
        { id: 2650, name: "Humidifiers" },
        { id: 2660, name: "Dehumidifiers" },
      ]},
    ],
  },

  /* 3000 — Large Appliances ------------------------------------------- */
  {
    id: 3000, name: "Appliances (Large)", children: [
      { id: 3100, name: "Refrigerators" },
      { id: 3200, name: "Freezers" },
      { id: 3300, name: "Ranges & Ovens" },
      { id: 3400, name: "Cooktops" },
      { id: 3500, name: "Microwaves (Built-in)" },
      { id: 3600, name: "Dishwashers" },
      { id: 3700, name: "Washers" },
      { id: 3800, name: "Dryers" },
    ],
  },

  /* 4000 — Grocery & Gourmet Food ------------------------------------- */
  {
    id: 4000, name: "Grocery & Gourmet Food", children: [
      { id: 4100, name: "Pantry Staples", children: [
        { id: 4110, name: "Rice, Pasta & Grains" },
        { id: 4120, name: "Flour & Baking" },
        { id: 4130, name: "Sugar, Sweeteners & Syrups" },
        { id: 4140, name: "Oils & Vinegars" },
        { id: 4150, name: "Canned & Jarred Goods" },
      ]},
      { id: 4200, name: "Beverages", children: [
        { id: 4210, name: "Water & Sparkling" },
        { id: 4220, name: "Soft Drinks" },
        { id: 4230, name: "Coffee" },
        { id: 4240, name: "Tea" },
        { id: 4250, name: "Juice" },
        { id: 4260, name: "Energy Drinks" },
      ]},
      { id: 4300, name: "Snacks", children: [
        { id: 4310, name: "Chips & Crisps" },
        { id: 4320, name: "Nuts & Seeds" },
        { id: 4330, name: "Candy & Sweets" },
        { id: 4340, name: "Chocolate" },
        { id: 4350, name: "Protein & Granola Bars" },
      ]},
      { id: 4400, name: "Breakfast Foods", children: [
        { id: 4410, name: "Cereal & Oats" },
        { id: 4420, name: "Spreads & Jams" },
        { id: 4430, name: "Pancake & Waffle Mix" },
      ]},
      { id: 4500, name: "Fresh & Chilled", children: [
        { id: 4510, name: "Produce" },
        { id: 4520, name: "Meat & Seafood" },
        { id: 4530, name: "Bakery" },
        { id: 4540, name: "Dairy & Eggs" },
      ]},
      { id: 4600, name: "Specialty & Diet", children: [
        { id: 4610, name: "Organic" },
        { id: 4620, name: "Gluten-Free" },
        { id: 4630, name: "Vegan" },
        { id: 4640, name: "Keto & Low-Carb" },
      ]},
      { id: 4700, name: "Baby Food" },
    ],
  },

  /* 5000 — Health & Personal Care ------------------------------------- */
  {
    id: 5000, name: "Health, Household & Personal Care", children: [
      { id: 5100, name: "Vitamins & Supplements" },
      { id: 5200, name: "Personal Care", children: [
        { id: 5210, name: "Oral Care" },
        { id: 5220, name: "Shaving & Hair Removal" },
        { id: 5230, name: "Deodorant" },
        { id: 5240, name: "Feminine Care" },
        { id: 5250, name: "Incontinence Care" },
      ]},
      { id: 5300, name: "Household Supplies", children: [
        { id: 5310, name: "Paper & Plastic" },
        { id: 5320, name: "Trash Bags" },
        { id: 5330, name: "Air Fresheners" },
        { id: 5340, name: "Batteries" },
      ]},
      { id: 5400, name: "Medical Supplies & Equipment", children: [
        { id: 5410, name: "Braces & Supports" },
        { id: 5420, name: "Thermometers" },
        { id: 5430, name: "Blood Pressure Monitors" },
      ]},
    ],
  },

  /* 6000 — Beauty ------------------------------------------------------ */
  {
    id: 6000, name: "Beauty & Grooming", children: [
      { id: 6100, name: "Makeup", children: [
        { id: 6110, name: "Face" },
        { id: 6120, name: "Eyes" },
        { id: 6130, name: "Lips" },
        { id: 6140, name: "Brushes & Tools" },
      ]},
      { id: 6200, name: "Skin Care", children: [
        { id: 6210, name: "Cleansers" },
        { id: 6220, name: "Moisturizers" },
        { id: 6230, name: "Serums" },
        { id: 6240, name: "Sunscreen" },
      ]},
      { id: 6300, name: "Hair Care", children: [
        { id: 6310, name: "Shampoo & Conditioner" },
        { id: 6320, name: "Styling Products" },
        { id: 6330, name: "Treatments" },
      ]},
      { id: 6400, name: "Fragrance", children: [
        { id: 6410, name: "Women" },
        { id: 6420, name: "Men" },
      ]},
      { id: 6500, name: "Men’s Grooming", children: [
        { id: 6510, name: "Beard Care" },
        { id: 6520, name: "Aftershave" },
      ]},
    ],
  },

  /* 7000 — Clothing, Shoes & Jewelry ---------------------------------- */
  {
    id: 7000, name: "Clothing, Shoes & Jewelry", children: [
      { id: 7100, name: "Women", children: [
        { id: 7110, name: "Clothing", children: [
          { id: 7111, name: "Dresses" },
          { id: 7112, name: "Tops & T-Shirts" },
          { id: 7113, name: "Jeans & Pants" },
          { id: 7114, name: "Skirts" },
          { id: 7115, name: "Outerwear" },
          { id: 7116, name: "Lingerie & Sleepwear" },
          { id: 7117, name: "Swimwear" },
        ]},
        { id: 7120, name: "Shoes", children: [
          { id: 7121, name: "Sneakers" },
          { id: 7122, name: "Heels" },
          { id: 7123, name: "Boots" },
          { id: 7124, name: "Flats" },
        ]},
        { id: 7130, name: "Accessories", children: [
          { id: 7131, name: "Bags & Wallets" },
          { id: 7132, name: "Belts" },
          { id: 7133, name: "Hats & Scarves" },
          { id: 7134, name: "Sunglasses" },
        ]},
        { id: 7140, name: "Jewelry", children: [
          { id: 7141, name: "Necklaces" },
          { id: 7142, name: "Earrings" },
          { id: 7143, name: "Rings" },
          { id: 7144, name: "Bracelets" },
        ]},
      ]},
      { id: 7200, name: "Men", children: [
        { id: 7210, name: "Clothing", children: [
          { id: 7211, name: "Shirts & Polos" },
          { id: 7212, name: "T-Shirts" },
          { id: 7213, name: "Jeans & Pants" },
          { id: 7214, name: "Suits & Blazers" },
          { id: 7215, name: "Outerwear" },
          { id: 7216, name: "Underwear & Socks" },
          { id: 7217, name: "Swimwear" },
        ]},
        { id: 7220, name: "Shoes", children: [
          { id: 7221, name: "Sneakers" },
          { id: 7222, name: "Dress Shoes" },
          { id: 7223, name: "Boots" },
          { id: 7224, name: "Sandals" },
        ]},
        { id: 7230, name: "Accessories", children: [
          { id: 7231, name: "Bags & Wallets" },
          { id: 7232, name: "Belts" },
          { id: 7233, name: "Hats" },
          { id: 7234, name: "Sunglasses" },
        ]},
        { id: 7240, name: "Watches & Jewelry" },
      ]},
      { id: 7300, name: "Kids & Baby", children: [
        { id: 7310, name: "Baby (0-24m)" },
        { id: 7320, name: "Girls" },
        { id: 7330, name: "Boys" },
        { id: 7340, name: "Shoes" },
        { id: 7350, name: "Accessories" },
      ]},
    ],
  },

  /* 8000 — Sports & Outdoors ------------------------------------------ */
  {
    id: 8000, name: "Sports & Outdoors", children: [
      { id: 8100, name: "Exercise & Fitness", children: [
        { id: 8110, name: "Cardio Equipment" },
        { id: 8120, name: "Strength Training" },
        { id: 8130, name: "Yoga & Pilates" },
      ]},
      { id: 8200, name: "Outdoor Recreation", children: [
        { id: 8210, name: "Camping & Hiking" },
        { id: 8220, name: "Cycling" },
        { id: 8230, name: "Scooters & Skate" },
        { id: 8240, name: "Fishing" },
        { id: 8250, name: "Climbing" },
      ]},
      { id: 8300, name: "Team Sports", children: [
        { id: 8310, name: "Soccer" },
        { id: 8320, name: "Basketball" },
        { id: 8330, name: "Tennis" },
        { id: 8340, name: "Golf" },
      ]},
      { id: 8400, name: "Water Sports" },
      { id: 8500, name: "Winter Sports" },
      { id: 8600, name: "Fan Shop" },
    ],
  },

  /* 9000 — Toys, Kids & Baby ------------------------------------------ */
  {
    id: 9000, name: "Toys, Kids & Baby", children: [
      { id: 9100, name: "Toys by Age", children: [
        { id: 9110, name: "0-2 Years" },
        { id: 9120, name: "3-5 Years" },
        { id: 9130, name: "6-8 Years" },
        { id: 9140, name: "9-12 Years" },
        { id: 9150, name: "13+ Years" },
      ]},
      { id: 9200, name: "Toy Categories", children: [
        { id: 9210, name: "Action Figures" },
        { id: 9220, name: "Dolls & Accessories" },
        { id: 9230, name: "Building Sets" },
        { id: 9240, name: "Puzzles" },
        { id: 9250, name: "STEM Toys" },
        { id: 9260, name: "Arts & Crafts" },
        { id: 9270, name: "Ride-Ons" },
        { id: 9280, name: "Outdoor Play" },
        { id: 9290, name: "Board Games" },
      ]},
      { id: 9300, name: "Baby Products", children: [
        { id: 9310, name: "Strollers" },
        { id: 9320, name: "Car Seats" },
        { id: 9330, name: "Nursery" },
        { id: 9340, name: "Feeding" },
        { id: 9350, name: "Diapering" },
        { id: 9360, name: "Bathing" },
        { id: 9370, name: "Safety" },
      ]},
    ],
  },

  /* 10000 — Pet Supplies ---------------------------------------------- */
  {
    id: 10000, name: "Pet Supplies", children: [
      { id: 10100, name: "Dog", children: [
        { id: 10110, name: "Food" }, { id: 10120, name: "Treats" }, { id: 10130, name: "Toys" },
        { id: 10140, name: "Beds & Furniture" }, { id: 10150, name: "Grooming" },
        { id: 10160, name: "Health" }, { id: 10170, name: "Collars & Leashes" },
        { id: 10180, name: "Bowls & Feeders" }, { id: 10190, name: "Carriers & Travel" },
      ]},
      { id: 10200, name: "Cat", children: [
        { id: 10210, name: "Food" }, { id: 10220, name: "Treats" }, { id: 10230, name: "Toys" },
        { id: 10240, name: "Beds & Trees" }, { id: 10250, name: "Grooming" }, { id: 10260, name: "Health" },
        { id: 10270, name: "Litter & Boxes" }, { id: 10280, name: "Bowls & Feeders" }, { id: 10290, name: "Carriers & Travel" },
      ]},
      { id: 10300, name: "Fish & Aquatic" },
      { id: 10400, name: "Small Animals" },
      { id: 10500, name: "Birds" },
      { id: 10600, name: "Reptiles" },
    ],
  },

  /* 11000 — Office Products ------------------------------------------- */
  {
    id: 11000, name: "Office & Stationery", children: [
      { id: 11100, name: "Office Electronics", children: [
        { id: 11110, name: "Printers" },
        { id: 11120, name: "Scanners" },
        { id: 11130, name: "Label Makers" },
      ]},
      { id: 11200, name: "Paper & Notebooks" },
      { id: 11300, name: "Writing Supplies" },
      { id: 11400, name: "Desk & Workspace", children: [
        { id: 11410, name: "Office Chairs" },
        { id: 11420, name: "Desks" },
        { id: 11430, name: "Monitor Stands" },
      ]},
      { id: 11500, name: "Filing & Organization" },
      { id: 11600, name: "School Supplies" },
    ],
  },

  /* 12000 — Industrial & Scientific ----------------------------------- */
  {
    id: 12000, name: "Industrial & Scientific", children: [
      { id: 12100, name: "Lab Supplies" },
      { id: 12200, name: "Test & Measurement" },
      { id: 12300, name: "Janitorial & Sanitation" },
      { id: 12400, name: "Material Handling" },
      { id: 12500, name: "Safety & PPE" },
      { id: 12600, name: "3D Printing" },
    ],
  },

  /* 13000 — Automotive -------------------------------------------------- */
  {
    id: 13000, name: "Automotive", children: [
      { id: 13100, name: "Replacement Parts", children: [
        { id: 13110, name: "Brakes" }, { id: 13120, name: "Filters" }, { id: 13130, name: "Engine Parts" },
      ]},
      { id: 13200, name: "Oils & Fluids" },
      { id: 13300, name: "Tires & Wheels" },
      { id: 13400, name: "Tools & Equipment" },
      { id: 13500, name: "Exterior Accessories" },
      { id: 13600, name: "Interior Accessories" },
      { id: 13700, name: "Car Care" },
    ],
  },

  /* 14000 — Tools & Home Improvement ---------------------------------- */
  {
    id: 14000, name: "Tools & Home Improvement", children: [
      { id: 14100, name: "Power Tools" },
      { id: 14200, name: "Hand Tools" },
      { id: 14300, name: "Tool Storage" },
      { id: 14400, name: "Electrical" },
      { id: 14500, name: "Lighting" },
      { id: 14600, name: "Hardware" },
      { id: 14700, name: "Plumbing" },
      { id: 14800, name: "Paint & Supplies" },
      { id: 14900, name: "Building Materials" },
      { id: 14950, name: "Safety & Security" },
    ],
  },

  /* 15000 — Garden & Outdoor ------------------------------------------ */
  {
    id: 15000, name: "Garden & Outdoor", children: [
      { id: 15100, name: "Patio Furniture" },
      { id: 15200, name: "Grills & Outdoor Cooking" },
      { id: 15300, name: "Gardening", children: [
        { id: 15310, name: "Soils & Fertilizers" },
        { id: 15320, name: "Seeds & Bulbs" },
        { id: 15330, name: "Garden Tools" },
      ]},
      { id: 15400, name: "Lawn Care" },
      { id: 15500, name: "Outdoor Lighting" },
    ],
  },

  /* 16000 — Arts, Crafts & Sewing ------------------------------------- */
  {
    id: 16000, name: "Arts, Crafts & Sewing", children: [
      { id: 16100, name: "Painting & Drawing" },
      { id: 16200, name: "Fabric" },
      { id: 16300, name: "Sewing Machines & Supplies" },
      { id: 16400, name: "Scrapbooking" },
      { id: 16500, name: "Beading & Jewelry Making" },
      { id: 16600, name: "Crafting Tools" },
    ],
  },

  /* 17000 — Musical Instruments & DJ ---------------------------------- */
  {
    id: 17000, name: "Musical Instruments & DJ", children: [
      { id: 17100, name: "Guitars" },
      { id: 17200, name: "Keyboards & MIDI" },
      { id: 17300, name: "Drums & Percussion" },
      { id: 17400, name: "Orchestral" },
      { id: 17500, name: "Recording Equipment" },
      { id: 17600, name: "Live Sound & PA" },
      { id: 17700, name: "DJ Equipment" },
    ],
  },

  /* 18000 — Books, Movies, Music & Games ------------------------------- */
  {
    id: 18000, name: "Books, Movies, Music & Games", children: [
      { id: 18100, name: "Books", children: [
        { id: 18110, name: "Fiction" },
        { id: 18120, name: "Non-Fiction" },
        { id: 18130, name: "Children’s Books" },
        { id: 18140, name: "Comics & Graphic Novels" },
      ]},
      { id: 18200, name: "Movies & TV" },
      { id: 18300, name: "Music (CD/Vinyl)" },
      { id: 18400, name: "Video Games", children: [
        { id: 18410, name: "Consoles" },
        { id: 18420, name: "Games" },
        { id: 18430, name: "Accessories" },
        { id: 18440, name: "PC Gaming" },
      ]},
    ],
  },

  /* 19000 — Software --------------------------------------------------- */
  {
    id: 19000, name: "Software", children: [
      { id: 19100, name: "Operating Systems" },
      { id: 19200, name: "Security" },
      { id: 19300, name: "Office" },
      { id: 19400, name: "Creative" },
      { id: 19500, name: "Developer Tools" },
    ],
  },

  /* 20000 — Luggage & Travel Gear ------------------------------------- */
  {
    id: 20000, name: "Luggage & Travel Gear", children: [
      { id: 20100, name: "Suitcases" },
      { id: 20200, name: "Carry-Ons" },
      { id: 20300, name: "Backpacks" },
      { id: 20400, name: "Duffel Bags" },
      { id: 20500, name: "Travel Accessories" },
    ],
  },

  /* 21000 — Handmade & Custom ----------------------------------------- */
  {
    id: 21000, name: "Handmade & Custom", children: [
      { id: 21100, name: "Home Décor" },
      { id: 21200, name: "Jewelry" },
      { id: 21300, name: "Clothing" },
      { id: 21400, name: "Gifts" },
    ],
  },

  /* 22000 — Digital & Services ---------------------------------------- */
  {
    id: 22000, name: "Digital Goods & Services", children: [
      { id: 22100, name: "Gift Cards" },
      { id: 22200, name: "Subscriptions" },
      { id: 22300, name: "Installation Services" },
      { id: 22400, name: "Extended Warranties" },
    ],
  },
];
